<core-external-automation-parameters [customerId]="data.customer.id" [nodeId]="systemId" [filter]="[{name : 'externalId1', value : 'myrspoven'}, {name : 'externalKey2', value : keyPrefix}]"></core-external-automation-parameters>
